import { Routes, Route } from 'react-router-dom';
import Public from './routes/Public';
import Auth from './routes/Auth';
import NotFound from './routes/NotFound';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Auth />} />
      <Route path="/public/:keyword" element={<Public />} />
      <Route path="/auth/:keyword" element={<Auth />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
